// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"bA","reportCardBox":"bA","report-img-wrap":"bB","reportImgWrap":"bB","report-title":"bC","reportTitle":"bC","report-date":"bD","reportDate":"bD"};